/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryEntryDetailResponse } from './RevisdomAPIViewModelsEntryEntryDetailResponse';
import {
    RevisdomAPIViewModelsEntryEntryDetailResponseFromJSON,
    RevisdomAPIViewModelsEntryEntryDetailResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryEntryDetailResponseToJSON,
    RevisdomAPIViewModelsEntryEntryDetailResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryEntryDetailResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1EntryDetailResponse
 */
export interface ApiResponse1EntryDetailResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1EntryDetailResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1EntryDetailResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryEntryDetailResponse}
     * @memberof ApiResponse1EntryDetailResponse
     */
    data?: RevisdomAPIViewModelsEntryEntryDetailResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1EntryDetailResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1EntryDetailResponse interface.
 */
export function instanceOfApiResponse1EntryDetailResponse(value: object): value is ApiResponse1EntryDetailResponse {
    return true;
}

export function ApiResponse1EntryDetailResponseFromJSON(json: any): ApiResponse1EntryDetailResponse {
    return ApiResponse1EntryDetailResponseFromJSONTyped(json, false);
}

export function ApiResponse1EntryDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1EntryDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryEntryDetailResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1EntryDetailResponseToJSON(json: any): ApiResponse1EntryDetailResponse {
    return ApiResponse1EntryDetailResponseToJSONTyped(json, false);
}

export function ApiResponse1EntryDetailResponseToJSONTyped(value?: ApiResponse1EntryDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryEntryDetailResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

